/**
 * ReportTransactionTemplate entity class
 *
 * Аналог ReportFinancialTemplate, но с url /report/transaction/*
 */
import moment from 'moment/moment'

/* @ngInject */
export default function ReportTransactionTemplateFactory ($http, $injector, Entity, onOffMixin, alertLiteSvc) {
  function ReportTransactionTemplate () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportTransactionTemplate.prototype = Object.create(Entity.prototype)
  ReportTransactionTemplate.prototype.constructor = ReportTransactionTemplate

  Object.assign(ReportTransactionTemplate.prototype, {
    _fields: {
      createdBy: String,
      createdTime: moment,
      reportTemplateId: Number,
      name: String,
      organizations: [{ name: String, organizationId: Number }],
      reportTemplateDetails:
        {
          reportName: String,
          periodType: String,
          periodCount: Number,
          createdBy: String,
          purchaseItemCategories: [String],
          purchaseItemStatuses: [String],
          paymentSystemTypes: [String],
          organizations: [{ name: String, organizationId: Number }],
          users: [],
          convertedAfterTrialDays: Number,
          firstActivation: Boolean,
          autoPay: Boolean,
          reportType: String,
          withoutTrial: Boolean,
          subscriptionsFilter: {
            dailySubscriptionLength: { from: Number, to: Number },
            monthlySubscriptionLength: { from: Number, to: Number },
            names: [String]
          }
        }
    },

    _urlTemplate: 'api/report/transactional/template/{{::reportTemplateId}}',
    _publicUrlTemplate: '/report/transactional/template/{{::reportTemplateId}}',

    _prepare: function () {
      this.reportDetails = this.reportTemplateDetails
    },

    _generate: function () {
      return $http.post(
        this._url,
        { templateId: this.id }
      ).catch(alertLiteSvc.alertError)
    }
  }, onOffMixin)

  ReportTransactionTemplate.getSubscriptions = function () {
    return $http.get('/report/transactional/extra')
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransactionTemplate.search = function (url, params) {
    return $http.post(url, { ...params })
      .data()
      .then((response) => response.payload)
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  ReportTransactionTemplate.extra = {
    subscriptions: [{ id: Number, name: String }]
  }

  Object.assign(ReportTransactionTemplate, Entity)
  ReportTransactionTemplate._name = 'ReportTransactionTemplate'
  ReportTransactionTemplate.init()

  return ReportTransactionTemplate
}
